import ListDescription from "features/configuration/InviteExternalUsers/ListDescription.tsx";
import { useContext } from "react";
import { ExternalConnectAccountContext } from "@shared/features/configuration/ExternalConnectAccount.context.ts";
import { getExternalInvitePermissionText } from "features/configuration/common/utils.ts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";
import { TranslationKeys } from "@shared/common/i18n/types";

const LoginDescription = () => {
  const { inviteData } = useContext(ExternalConnectAccountContext)!;
  const { t } = useTypedTranslation(LanguageNameSpaces.AUTH);

  const getTexts = () => {
    return [
      t("external_connect.login_description.continue"),
      t("external_connect.login_description.exchange_linked"),
      t(
        getExternalInvitePermissionText(
          inviteData
        ) as TranslationKeys<LanguageNameSpaces.AUTH>
      ),
    ];
  };

  return <ListDescription texts={getTexts()} />;
};

export default LoginDescription;
